import React from 'react';
import {useTranslation } from "react-i18next";   


function WhyUs() {
    const { t, i18n } = useTranslation();
    return (
    <section id="why-us" className="why-us">
        <div className="container" >
            <div className="section-title">
                <h2>{t("wcy-expect")}</h2>
                <p>{t("about-us")} <span className="text-old">Old Tbilisi</span> </p>
            </div>
            <div className="row">
                <div className="col-lg-4">
                    <div className="box">
                        <span>01</span>
                        <h4>{t("wcy-expect-h1")}</h4>
                        <p>{t("wcy-expect-p1")}</p>
                    </div>
                </div>                
                <div className="col-lg-4 mt-4 mt-lg-0">
                    <div className="box">
                    <span>02</span>
                    <h4>{t("wcy-expect-h2")}</h4>
                    <p>{t("wcy-expect-p2")}</p>
                    </div>
                </div>
                <div className="col-lg-4 mt-4 mt-lg-0">
                    <div className="box">
                    <span>03</span>
                    <h4>{t("wcy-expect-h3")}</h4>
                    <p className="pb-2">{t("wcy-expect-p3")}</p>
                    <br></br>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}

export default WhyUs;
